<template>
  <div>
    <nav class="navbar navbar-expand-sm fixed-top navbar-dark navbar-bg" aria-label="Main navigation">
      <div class="container-fluid">
        <div class="navbar-brand bg-white" href="#">
          <!--img class="bi mx-1" src="../assets/AIMS2GOlogo.png" alt="" width="142" style="filter: invert(1) saturate(0)"-->
          <img class="bi mx-1" src="../assets/AIMS2GOlogo.png" alt="" width="142" style="">
        </div>
        <button class="navbar-toggler p-0 border-0" type="button" id="navbarSideCollapse" @click="onClickNavBarSideCollapse" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="navbar-collapse offcanvas-collapse" id="navbarsExampleDefault" ref="navbarsExampleDefault">
          <ul class="navbar-nav me-auto mb-2 mb-sm-0">
            <li class="nav-item">
              <router-link to="/" class="nav-link" active-class="active">
                <show-icon name="home" size="xs" class="align-middle"></show-icon>
                <span class="align-middle">&nbsp;{{ $t('home') }}</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/sites" class="nav-link" active-class="active">
                <show-icon name="business" size="xs" class="align-middle"></show-icon>
                <span class="align-middle">&nbsp;{{ t('models.site', 2) }}</span>
              </router-link>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-bs-toggle="dropdown" aria-expanded="false">
                <show-icon name="settings" size="xs" class="align-middle"></show-icon>
                {{ t ("settings") }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="dropdown01">
                <li>
                  <router-link :to="{ name: 'ClearData' }" active-class="active" class="dropdown-item">
                    <show-icon name="delete" size="xs" class="align-middle"></show-icon>
                    <span class="align-middle">&nbsp;{{ $t('clear_data') }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="switch_lang" data-bs-toggle="dropdown" aria-expanded="false">
                <show-icon name="language" size="xs" class="align-middle"></show-icon>
                <span class="align-middle">&nbsp;{{ t ("language") }}</span>
              </a>
              <ul class="dropdown-menu" aria-labelledby="switch_lang">
                <li><a href="#" class="dropdown-item" @click="switchLang('en')"><span class="align-middle">{{ t("english") }}</span></a></li>
                <li><a href="#" class="dropdown-item" @click="switchLang('es')"><span class="align-middle">{{ t("spanish") }}</span></a></li>
              </ul>
            </li>
          </ul>
          <!--form class="d-flex">
            <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
            <button class="btn btn-outline-success" type="submit">Search</button>
          </form-->
          <template v-if="authenticated()">
            <button class="btn btn-outline-success" type="button" @click="onClickLogout">
              <show-icon name="logout" size="xs" class="align-middle"></show-icon>
              {{$t('logout')}}
            </button>
          </template>
          <template v-else>
            <button class="btn btn-outline-success" type="button" @click="onClickLogin">
              <show-icon name="account_circle" size="xs" class="align-middle"></show-icon>
              {{$t('login')}}
            </button>
          </template>
        </div>
      </div>
    </nav>    

    <slot name="submenu"></slot>

    <main class="container">
      <div class="col-lg-10 col-12 p-2 mx-auto">
        <slot />
      </div>
    </main>

    <LoginDialog :show-login-dialog="showLogin" 
                 @close-login="onClickClose"
                 @login-successful="onLoginSuccessful"></LoginDialog>

    <Footer></Footer>
  </div>
</template>

<script>
/**
 * Template reference: https://getbootstrap.com/docs/5.0/examples/offcanvas-navbar/
 */
import Footer from '@/components/Footer.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import { currentUser, authenticated } from '@/common/user_helpers'

import { useI18n } from 'vue-i18n'

export default {
  name: "AppLayout",
  setup() {
    const { t, locale } = useI18n({ useScope: 'global' });

    const switchLang = function(lang) {
      locale.value = lang;
    }

    return {
      currentUser,
      authenticated,
      t,
      locale,
      switchLang
    }
  },
  data() {
    return {
      showLogin: false,
      afterLoginCallback: null
    }    
  },
  components: {
    Footer,
    LoginDialog
  },
  methods: {
    onClickNavBarSideCollapse(e) {
      console.log("Inside AppLayout.vue onClickNavBarSideCollapse, e ==> ", e);
      console.log("Inside AppLayout.vue onClickNavBarSideCollapse, this.$refs.navbarsExampleDefault ==> ", this.$refs.navbarsExampleDefault);
      this.$refs.navbarsExampleDefault.classList.toggle('open')
    },
    onClickLogin() {
      this.goLogin();
    },
    goLogin(callbackFunc) {
      console.log("Inside AppLayout.vue launchLoginDialog, callbackFunc ==> ", callbackFunc);
      // show login dialog box
      this.showLogin = true;
      // register the call back function
      this.afterLoginCallback = callbackFunc;
    },
    onClickClose() {
      this.showLogin = false
    },
    onLoginSuccessful(user) {
      console.log("Inside AppLayout.vue onLoginSuccessful, user ==> ", user);
      alert(this.$t("login_successful"));
      this.showLogin = false;
      // if there is a callback for afterlogin, call it
      if (this.afterLoginCallback) {
        this.afterLoginCallback(user)
      }
    },
    onClickLogout() {
      this.$store.dispatch("logoutUser");
    }
  }
}
</script>
